import replaceShort from './stringHandling';
/**
 * Get deep nested data from object passing string of keys joined by dots for specific language
 * example getDeepData(data, 'key1.key2.key3', "sk")
 * gets slovak message from data.key1.key2.key3.sk
 */
const getDeepData = (data, path, lang = 'sk') => {
  let returnData = data;
  for (let i = 0, p = path.split('.'), len = p.length; i < len; i += 1) {
    if (typeof returnData[p[i]] === 'undefined')
      throw new Error(`${p[i]} is undefined in ${path}`);

    returnData = returnData[p[i]];
  }
  return returnData && typeof returnData === 'object'
    ? returnData[lang]
    : returnData;
};

/**
 * Get string value not wrapping after short words
 * useful for longer texts of paragraphs
 */
const getString = (data, path, lang) =>
  replaceShort(getDeepData(data, path, lang));

/**
 * Get deep value shortcut for getDeepData
 */
const getData = (data, path, lang) => getDeepData(data, path, lang);

export default getData;
export { getDeepData, getString };



// WEBPACK FOOTER //
// ./src/scripts/lib/dataHandling.js